import { render, staticRenderFns } from "./rmsMarketsegmentReport.vue?vue&type=template&id=b6898e28&scoped=true"
import script from "./rmsMarketsegmentReport.vue?vue&type=script&lang=js"
export * from "./rmsMarketsegmentReport.vue?vue&type=script&lang=js"
import style0 from "./rmsMarketsegmentReport.vue?vue&type=style&index=0&id=b6898e28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6898e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
